import { take, put, call, select, takeEvery } from 'redux-saga/effects';
import { EventChannel } from 'redux-saga';
import * as constants from '../../resource/meeting-simple/meeting-simple.constants';
import { IPusherAction, createSagaEventChannelForPusherChannel, pusher } from './pusher.connection';
import { SOCKET_CONFIG } from '../socket.configs';
import { userSelectors } from '../../resource/user/user.selectors';
import { authSelectors } from '../../auth/auth.selectors';
import { IUser } from '../../resource/user/user.types';
import { IMeetingSimple } from '../../resource/meeting-simple/meeting-simple.types';
import { addFlashMessage } from '../../../utils/flashMessages.utils';

export function* watchOnPusherMeetingRcvMessage(socketChannel: EventChannel<IPusherAction>) {
  while (true) {
    try {
      // take an message from the queue that has the messages emitted by the PusherChannel
      // the message has the format of IPusherAction
      const action = (yield take(socketChannel)) as IPusherAction;
      // the message is sent, as an action (since it has the proper structure), to a dispatch
      yield put(action);
    } catch (err) {
      console.error('Meeting Pusher socket error:', err);
    }
  }
}

export function* pusherMeetingSagaWatcher() {
  // called with every Meeting list saved in the store
  yield takeEvery(constants.STORE_MEETING_SIMPLE, function* (action: IPusherAction) {
    console.debug(`Meeting ID = ${action.payload?.id} is updated in the store (STORE_MEETING_SIMPLE).`);
    const currentId = (yield select(authSelectors.selectLoggedUser)) as IUser['id'];
    const user = (yield select(userSelectors.selectResourceById, currentId)) as IUser;
    const meeting = action.payload as IMeetingSimple;

    if (!user) {
      console.error('The user is not loaded when setting up Meeting Pusher channels.');
      addFlashMessage({
        type: 'error',
        message: 'Your session was not properly loaded, please refresh the page.',
        reloadOnCountdown: true,
      });
      return;
    }

    const meetingPusherChannelName = `acc-${user.tenantId}-${meeting.id}`;

    // only if the channel is not already created
    if (!pusher.channel(meetingPusherChannelName)) {
      // Create the Saga EventChannel, that will be queueing messages from the Pusher Channel
      const pusherChannelEventChannel = (yield call(
        createSagaEventChannelForPusherChannel,
        meetingPusherChannelName,
        SOCKET_CONFIG.actions,
      )) as EventChannel<IPusherAction>;

      // define the watch function that will be polling from that EventChannel
      yield call(watchOnPusherMeetingRcvMessage, pusherChannelEventChannel);
    } else {
      // do nothing
      // console.warn(`The Pusher channel '${meetingPusherChannelName}' is already subscribed. So do nothing.`);
    }
  });
}
